import { baseApi } from "../../../../app/api";

const CUSTOM_REST_API_BASE =
  window.commonVariables?.customRestApiBase || "/wp-json/ecommerce-app/v1";

export interface AvailableSlot {
  time: string;
  status: string;
}

export interface AppointmentSlotsResponse {
  is_closed: boolean;
  message?: string;
  slots: AvailableSlot[];
}

export const appointmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAvailableSlots: builder.query<AppointmentSlotsResponse, string>({
      query: (date) => ({
        url: `${CUSTOM_REST_API_BASE}/appointments/available-slots`,
        params: { date },
      }),
    }),
  }),
});

export const { useGetAvailableSlotsQuery, useLazyGetAvailableSlotsQuery } =
  appointmentApi;
